import { render, staticRenderFns } from "./DetailsButton.vue?vue&type=template&id=eaaaba42&"
import script from "./DetailsButton.vue?vue&type=script&lang=js&"
export * from "./DetailsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports